import { createJSONRequest } from './create-request.js'

/**
 * Every physical site an actor is known to have — its head office, its subsidiary actors, and the
 * locations the LinkedIn and Augmented Actor Profile enrichers recorded in the services database.
 *
 * Those last ones are not on the actor payload: they only become subsidiary actors when
 * `ds:migrate-central-profile-locations` is run, so counting `actor.subsidiaries` alone understates
 * the footprint of every company that has been enriched but not yet migrated.
 *
 * Deduplicated by city server-side, so the count can be shown as-is.
 */
export const fetchActorLocations = (actorId) => createJSONRequest({
  url: `/api/actors/${actorId}/locations`,
  method: 'GET',
})
